var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3707 3.09381C15.8847 1.36534 20.5701 1.36532 21.7414 5.97461C22.9128 10.5839 19.8165 19.0756 18.2274 20.9548C16.8752 22.554 14.9178 21.9598 14.7134 20.0279C14.2449 15.5989 12.9564 14.5752 12.3707 14.617C10.7698 14.617 10.3629 17.3277 10.047 19.4325C10.0162 19.6377 9.98623 19.8372 9.95612 20.0279C9.66961 21.8424 7.50754 22.9116 6.31409 20.9548C4.7523 18.2661 1.98013 11.5058 3.38574 5.97468C4.79135 0.443533 10.028 1.94149 12.3707 3.09381ZM8.27112 3.55469C6.61581 3.55469 4.59284 5.11618 4.59277 8.3378C4.59276 8.75201 4.92854 9.08781 5.34276 9.08782C5.75697 9.08782 6.09276 8.75205 6.09277 8.33783C6.09283 5.79784 7.58376 5.05469 8.27112 5.05469C8.68534 5.05469 9.02112 4.7189 9.02112 4.30469C9.02112 3.89047 8.68534 3.55469 8.27112 3.55469Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth);
export default __webpack_public_path__ + "static/media/tooth.83742e222be33b4033bfb7d07ddd2b5f.svg";
export { ForwardRef as ReactComponent };